export const LOAD_LOGISTIC = 'LOAD_LOGISTIC';
export const SET_LOGISTIC_FILTERS = 'SET_LOGISTIC_FILTERS';
export const RESET_LOGISTIC_FILTERS = 'RESET_LOGISTIC_FILTERS';
export const SET_LOGISTIC_PAGINATION = 'SET_LOGISTIC_PAGINATION';
export const SET_CHECKED_LOGISTIC = 'SET_CHECKED_LOGISTIC';
export const SET_LOGISTIC_COMMENT = 'SET_LOGISTIC_COMMENT';
export const SIMPLE_PRINT_LABEL = 'SIMPLE_PRINT_LABEL';
export const PRINT_GROUPED_LABEL = 'PRINT_GROUPED_LABEL';
export const SET_PRINT_LABEL_POPUP = 'SET_PRINT_LABEL_POPUP';
export const SET_SUBMITTING = 'SET_SUBMITTING';
export const SET_LOGISTIC_NEEDED_DATA = 'SET_LOGISTIC_NEEDED_DATA';
export const SEND_DEMAND_CONVOCATION_TNT = 'SEND_DEMAND_CONVOCATION_TNT';
export const LOAD_TNT_DOCUMENTS = 'LOAD_TNT_DOCUMENTS';
export const SET_TNT_DOCUMENTS_FILTERS = 'SET_TNT_DOCUMENTS_FILTERS';
export const RESET_TNT_DOCUMENTS_FILTERS = 'RESET_TNT_DOCUMENTS_FILTERS';
export const SET_TNT_DOCUMENTS_PAGINATION = 'SET_TNT_DOCUMENTS_PAGINATION';
export const DELETE_LOGISTIC_LABEL = 'DELETE_LOGISTIC_LABEL';
export const LOAD_TNT_LABEL = 'LOAD_TNT_LABEL';
export const SET_TNT_LABEL_FILTERS = 'SET_TNT_LABEL_FILTERS';
export const RESET_TNT_LABEL_FILTERS = 'RESET_TNT_LABEL_FILTERS';
export const SET_TNT_LABEL_PAGINATION = 'SET_TNT_LABEL_PAGINATION';
